module.exports = __webpack_public_path__ + "static/media/btn-instrument-pitch-on.ae53a4d0.svg";